import { render, staticRenderFns } from "./ProcurementManagement.vue?vue&type=template&id=24bde936&scoped=true&"
import script from "./ProcurementManagement.vue?vue&type=script&lang=js&"
export * from "./ProcurementManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProcurementManagement.vue?vue&type=style&index=0&id=24bde936&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bde936",
  null
  
)

export default component.exports